export default {
  list: {
    title: 'アカウントセンター',
    createButton: 'アカウント作成',
    searchPlaceholder: 'ユーザー名/メールアドレスを検索',
    total: '合計',
    unit: '件',
    columns: {
      username: 'ユーザー名',
      email: 'メールアドレス',
      department: '部署名称',
      role: 'アカウント役割',
      careerRole: 'Career 権限',
      talentRole: 'Talent 権限',
      status: '状態',
      creator: '作成者',
      createTime: '作成日時',
      systemCreator: 'システム作成',
      operations: '操作',
    },
    operations: {
      edit: '編集',
      delete: '削除',
    },
  },
  createDialog: {
    title: 'アカウント作成',
    editTitle: 'アカウント編集',
    create: '作成',
    save: '保存',
    username: 'ユーザー名',
    usernamePlaceholder: '入力してください',
    email: 'メールアドレス',
    emailPlaceholder: '入力してください',
    department: '部署名称',
    departmentPlaceholder: '入力してください',
    careerRole: 'Career',
    talentRole: 'Talent',
    careerRoleName: 'Career 権限',
    talentRoleName: 'Talent 権限',
    roleSelectPlaceholder: '選択してください',
    admin: '管理者',
    normal: '普通アカウント',
    adminHint: '企業情報を作成変更できる',
    normalHint: '作成済みの社員及びタスクのみ管理',
    cancel: 'キャンセル',
    confirm: '確定',
    validation: {
      usernameRequired: 'ユーザー名を入力してください',
      emailRequired: 'メールアドレスを入力してください',
      emailInvalid: '入力されたメールアドレスの形式が正しくありません',
      emailExists: 'アカウントが既に存在します',
      emailExistsInOtherCompany: '該当アカウントはすでに別の企業に所属しています。元の会社の管理者に連絡して削除いただくか、別のメールアドレスをご使用ください。',
      departmentRequired: '部署名称を入力してください',
      roleRequired: '役割を選択してください',
      atLeastOneRole: '少なくとも1つの役割を選択してください',
    },
    fetchDetailError: 'アカウント詳細の取得に失敗しました',
    fetchRolesError: 'ロールリストの取得に失敗しました',
    saveAccountError: 'アカウントの保存に失敗しました',
  },
  status: {
    active: 'アクティブ',
    unactive: '非アクティブ',
    lock: 'ロック',
  },
  deleteDialog: {
    title: '確認',
    content: '削除すると復元できず、アカウントはシステムにログインできなくなります。アカウント「{username}」を削除してもよろしいですか？',
  },
  editDialog: {
    title: 'お知らせ',
    content: '自身のアカウントは編集できません',
  },
  detail: {
    title: '個人情報',
    username: 'ユーザー名',
    email: 'メールアドレス',
    password: 'パスワード',
    department: '部署名称',
    role: '役割',
    careerRole: 'Career役割',
    talentRole: 'Talent役割',
    save: '保存',
    cancel: 'キャンセル',
    updateEmail: 'メールアドレス変更',
    modifyPassword: 'パスワード変更',
  },
  updateEmailDialog: {
    title: 'メールアドレス変更',
    step1Description: '新しいメールアドレスを入力してください。新しいメールアドレスに確認リンクを送信します。リンクを通じて確認後、新しいメールアドレスが有効になります。',
    step2Description: '{email}にメールアドレス変更のメールを送信しました。メールを受信し、メール内の指示に従って操作してください。',
    inputPlaceholder: '入力してください',
    cancel: 'キャンセル',
    confirm: '確定',
    known: '了解しました',
    validation: {
      emailRequired: 'メールアドレスを入力してください',
    },
  },
  updatePasswordDialog: {
    title: 'パスワード変更',
    oldPassword: '旧パスワード',
    newPassword: '新パスワード',
    confirmPassword: '新パスワードを再入力',
    inputPlaceholder: '入力してください',
    newPasswordPlaceholder: 'パスワードは8文字以上で、英字と数字を含む必要があります',
    cancel: 'キャンセル',
    confirm: '確定',
    successMessage: 'パスワードが正常に変更されました',
    validation: {
      oldPasswordRequired: '旧パスワードを入力してください',
      newPasswordRequired: '新パスワードを入力してください',
      passwordLength: 'パスワードは8文字以上である必要があります',
      passwordFormat: 'パスワードは英字と数字を含む必要があります',
      confirmPasswordRequired: '新パスワードを再入力してください',
      passwordMismatch: '入力されたパスワードが一致しません',
    },
  },
  messages: {
    updateSuccess: '変更が正常に完了しました',
  },
  roles: {
    superAdmin: 'オーナー',
    admin: '管理者',
    recruitManager: '管理者',
    recruiter: 'HR',
    user: '普通アカウント',
    interviewer: '面接官',
    op: '運営サポート',
  },
  noPermission: 'アクセス権限なし',
  notPurchased: 'この製品はまだ購入されていません。営業担当者にお問い合わせください。',
  noRolePermission: '本アカウントは {roleType} において権限がありません。'
};
